module.exports = __webpack_public_path__ + "img/mygolf.0bfff800.png";